export default __webpack_public_path__ + "assets/images/892ae8bf9538521c42dadd8d5795915c.png";